import { LaborDownload } from './LaborDownload';

const labDownloads = document.querySelectorAll('.tx-avmplugins-labdownload');

labDownloads.forEach((element) => {
    new LaborDownload(element);
});
